/**
 * Какие проекты ищет поиск в списке нового дизайна (GET /api/projects?q=…&scope=…) — общий модуль сервера и клиента
 * (в клиенте — алиас @projectSearch). Без зависимостей: его собирают обе стороны.
 *   all    — все, как раньше: в работе, готовые и архив;
 *   active — в работе: не «Готов» и не в архиве;
 *   ready  — готовые: «Готов» или в архиве. active и ready вместе — ровно all.
 */
export const PROJECT_SEARCH_SCOPES = ['all', 'active', 'ready'] as const;

export type ProjectSearchScope = (typeof PROJECT_SEARCH_SCOPES)[number];

/** Ответ GET /api/projects/search-counts?q=…: сколько проектов найдено в каждой области. */
export type ProjectSearchCounts = Record<ProjectSearchScope, number>;
